import { observer } from 'mobx-react'
import React, { useCallback, useEffect, useRef } from 'react'
import RootStore from '../../../store/RootStore'
import { Flex, useDisclosure } from '@chakra-ui/react'
import { Chart } from './Chart'
import ChartTip from './ChartTip'
import PropTypes from 'prop-types'
import { makeTextsHighlighted } from '../../../utils/SearchHelper'
import ChartDrawer from './ChartDrawer'

export const ChartItem = observer(({ chartId, ...rest }) => {
  const {
    reportStore: { viewType, reportId },
    chartStore: { charts, setChartId },
    searchStore: { searchText, filteredCurrentResult },
  } = RootStore

  const { isOpen, onClose, onOpen } = useDisclosure()

  const chartTipRef = useRef(null)
  const chartContainerRef = useRef(null)
  const chartInstance = useRef(null)

  const handleChartClick = useCallback(() => {
    setChartId(chartId)
  }, [chartId, setChartId])

  useEffect(() => {
    if (chartTipRef.current && chartContainerRef.current) {
      makeTextsHighlighted(chartTipRef.current, searchText)
      makeTextsHighlighted(chartContainerRef.current, searchText)
    }
  }, [filteredCurrentResult, searchText])

  return (
    <Flex
      pos="relative"
      m={{ base: '12px 0', md: '0' }}
      p={{ base: '0', md: '0 16px 24px 16px' }}
      data-searchable={true}
      w={{
        base: '100%',
        lg: viewType.value === '2x2' ? '50%' : '100%',
      }}
      {...rest}>
      <Chart
        chartInstance={chartInstance}
        chart={charts[chartId]}
        onClick={onOpen}
      />
      {charts[chartId]?.text && viewType.value === 'full' && (
        <ChartTip
          title={charts[chartId].title}
          text={charts[chartId].text}
          ref={chartTipRef}
        />
      )}
      {charts[chartId]?.drillDownInfo?.linkages?.values && (
        <>
          <ChartDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={charts[chartId]?.title}
            drillDownInfo={charts[chartId]?.drillDownInfo}
            reportId={reportId}
            onChartClick={handleChartClick}
          />
        </>
      )}
    </Flex>
  )
})

ChartItem.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  tooltipHeader: PropTypes.string,
  text: PropTypes.string,
  showTooltip: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  checkboxCheck: PropTypes.bool,
  onSetDownloadselection: PropTypes.func,
  drilldowns: PropTypes.array,
  id: PropTypes.string,
}

ChartItem.displayName = 'ChartItem'
